import { ApplicationConfig } from 'shared-utils';

export const environment: ApplicationConfig = {
  production: false,
  url: 'https://test.allianzretailportal.com',
  healthCheckUrl: 'https://test.allianzretailportal.com',
  config: {
    errorInfo: true,
    hideSettings: true,
    sessionIdleTimeMs: 25 * 60 * 60 * 1000,
    sessionExpireTimeMs: 7 * 24 * 60 * 60 * 1000,
    reportItemsPerPage: 100,
  },
  forgeRock: {
    clientId: 'testapp',
    baseUrl: 'https://id.dev.allianzretailportal.com',
    redirectUri: 'https://test.allianzretailportal.com/silent-refresh/',
    oauthThreshold: 90 * 1000,
    timeout: 15 * 1000,
  },
  impersonation: {
    baseUrl: 'https://preprod.retail.allianz.nl',
    env: 'allianzdirectpreprod',
    clientId: '0a408f38-f275-4815-bb09-87a9a6c7d666',
  },
  adapterUrls: {
    rsaNl: 'https://az-partners-rsa-adapter.api.test.allianzretailportal.com',
  },
  partyUrl: 'https://data-management-service.api.test.allianzretailportal.com',
  policyUrl: 'https://data-management-service.api.test.allianzretailportal.com',
  notificationUrl: 'https://notification-service.api.test.allianzretailportal.com',
  identityManagementUrl: 'https://identity-management-service.api.test.allianzretailportal.com',
  partnersPowerbiUrl: 'https://az-partners-powerbi-adapter.api.test.allianzretailportal.com',
  reportAdapterUrl: 'https://az-partners-report-adapter.api.test.allianzretailportal.com',
  featureToggleUrl: 'https://feature-toggle-service.api.test.allianzretailportal.com',
  translationUrl: 'https://translation-service.api.test.allianzretailportal.com',
  santanderUrl: 'https://az-partners-cil-adapter.api.test.allianzretailportal.com',
  paymentUrl: 'https://payment-page.uat.aws.emagin.eu/#/payment/',
  oneTrustId: '019624e2-f4cc-7f54-8e76-4b28c6abbeee-test',
};
